// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dNYh2","question":"styles_question__1mGzz","description":"styles_description__mT-qy"};